import { useEffect } from 'react'
import cssVars from 'css-vars-ponyfill'

const useViewportResize = () => {
    useEffect(() => {
        cssVars()

        let vw = window.innerWidth * 0.01
        let vh = window.innerHeight * 0.01

        document.documentElement.style.setProperty('--vw', `${vw}px`)
        document.documentElement.style.setProperty('--vh', `${vh}px`)

        const handleWindowResize = () => {
            vw = window.innerWidth * 0.01;
            vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vw', `${vw}px`)
            document.documentElement.style.setProperty('--vh', `${vh}px`)
        };

        window.addEventListener('resize', handleWindowResize)

        return () => window.removeEventListener('resize', handleWindowResize)
    }, [])
}

export default useViewportResize